import RadioCheckedIcon from 'assets/icons/radio-checked-icon.svg';
import RadioNotAllowIcon from 'assets/icons/radio-disable-icon.svg';
import RadioboxHHMTIcon from 'assets/icons/radiobox-hhmt-icon.svg';
import RadioboxRemoxIcon from 'assets/icons/radiobox-remox-icon.svg';
import { DESKTOP_MIN_WIDTH, FUNC_DEFAULT, OBJECT_DEFAULT } from 'constants';
import { Fade } from 'helpers/animation';
import useTheme from 'hooks/useTheme';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputRadioCheckbox = ({
  isChecked = false,
  onClick = FUNC_DEFAULT,
  styles = OBJECT_DEFAULT,
  isNotAllowSelect = false,
}) => {
  const { isHHMTTheme } = useTheme();

  const handleOnChange = () => {
    if (isNotAllowSelect) return;
    onClick && onClick();
  };

  return (
    <FormCheckStyled
      type="checkbox"
      label=""
      checked={isChecked}
      onChange={handleOnChange}
      readOnly={true}
      style={{ ...(styles || {}) }}
      $checkboxSrc={isHHMTTheme ? RadioboxHHMTIcon : RadioboxRemoxIcon}
      $notAllowCheckbokSrc={RadioNotAllowIcon}
      $isNotAllowSelect={isNotAllowSelect}
    />
  );
};

const FormCheckStyled = styled(Form.Check)`
  margin: 0;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-left: 24px;
    margin-inline: 0px;
    margin-bottom: 4px;
  }

  label {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    color: var(--ds-c-grey-dark);
    margin-left: 5.5px;

    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  input {
    border: none;
    border-radius: 2px;
    background-image: ${(props) => `url(${props.$checkboxSrc}) !important`};
    width: 16px;
    height: 16px;
    cursor: pointer;
    background-color: transparent;

    ${(props) =>
      props.$isNotAllowSelect &&
      `
      cursor: not-allowed;
      background-image: ${`url(${props.$notAllowCheckbokSrc})!important`};
    `}

    &:focus,
    &:active,
    &:checked {
      background-color: transparent;
      border: none;
      border-radius: 2px;
      box-shadow: none !important;
      filter: none !important;
    }
  }

  input:checked[type='checkbox'] {
    background-image: url(${RadioCheckedIcon}) !important;
  }
`;

export default FormInputRadioCheckbox;
